/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-05 14:16:11
 * @Description: 
 */

// ▼用于游戏下方的结果区的“页签组件”
export const oResultTab = {
    'history': {
        en: 'History', 
        cn: '历史',
    },
    'my_bets': {
        en: 'My Bets', 
        cn: '我的押注',
    },
    'high_rollers': {
        en: 'High Rollers', 
        cn: 'High Rollers',
    },
    'rare_wins': {
        en: 'Rare Wins', 
        cn: '罕见赢分',
    },
    'all_bets':{
        en: 'All Bets', 
        cn: '全部押注',
    },
    'bets_online':{
        en: 'Bets Online', 
        cn: '在线押注',
    },
    // ---  ↓ waves 游戏的页签 ---------------- 
    'active':{
        en: 'Active', 
        cn: '活跃中',
    },
    'closed':{
        en: 'Closed', 
        cn: '已关闭',
    },
    'public':{
        en: 'Public', 
        cn: '公开',
    },
    'leaderboard':{
        en: 'Leaderboard', 
        cn: '排行榜', 
    },
    'futures': { // 首页表格的标题 
        en: 'Futures', 
        cn: '期货',
    },
};


// ▼ 用于闪电图标
export const oRTP = {
    'RTP': {
        en: 'RTP:',
        cn: 'RTP:',
    },
    'RTP_description': {
        en: '⚡️ One of the TOP RTP in iGaming',
        cn: '⚡️ 网路博彩业界最高的 RTP',
    },
    'eRTP': {
        en: 'eRTP:',
        cn: 'eRTP:',
    },
    'eRTP1': {
        en: 'eRTP ({rank} rank):',
        cn: 'eRTP ({rank} rank):',
    },
    'eRTP_description': {
        en: '(Effective RTP with bonuses for your current Rank)',
        cn: '(eRTP 计算依据您当前等级且包含奖励)',
    },
};

// ▼ 用于输入框的最大值最小值提示
export const oMinMaxTip = {
    'min_coefficient': {
        en: 'ℹ️ Min coefficient is ●x',
        cn: 'ℹ️ 最小倍数为 ●x',
    },
    'max_coefficient': {
        en: 'ℹ️ Max coefficient is ●x',
        cn: 'ℹ️ 最大倍数为 ●x',
    },
};

// ▼收藏按钮
export const oFavoriteBtn = {
    btnName: {
        en: 'Favorite',
        cn: '喜欢',
    },
    tips: {
        en: 'Add to favorite',
        cn: '添加收藏',
    }
}


// ▼语言相关
export const oLang = {
    language: {
        en: 'Language',
        cn: '语言',
    },
    en: {
        en: 'English',
        cn: 'English',
    },
    cn: {
        en: '中文',
        cn: '中文',
    }
}


// ▼音乐控制面板
export const oMusic = {
    allSounds: {
        en: 'All Sounds',
        cn: '全部声音',
    },
    Music: {
        en: 'Music',
        cn: '音乐',
    },
    Effects: {
        en: 'Effects',
        cn: '音效',
    }
}



// ▼ jackpot 弹出窗口
export const oJackpot = {
    rest: {
        en: 'The rest percent of Jackpot after winnings goes to the next bankroll',
        cn: 'Jackpot的剩余百分比将用于下次',
    },
    LastWinners: {
        en: 'Last winners',
        cn: '最后的获奖者',
    },
    plinkoDescText1: {
        cn: '在 Plinko 押注就有机会赢得 Jackpot。赢得 Plinko字母所在的倍率即可点亮字母，集齐所有字母就能赢得Jackpot。用户收集到的字母会持续保留直到赢得 Jackpot。押注大小将会决定能够获得的Jackpot 百分比，其分配如下所示。',
        en: 'To win Jackpot you should place bets in Plinko game. Every multiplier has his own letter from PLINKO word. You should collect all the letters to win Jackpot. Letters will stay collected for every user until Jackpot will be won. Percent of Jackpot winnings depends on the lowest bet amount and the distribution is represented below.'
    },
    diceDescText1: {
        en: 'To win Jackpot you should place bets in Dice game. The lucky combination must match by first digits eight times 5x -> 5x -> 5x -> 5x -> 5x -> 5x -> 5x -> 5x (inclusive), where x is any number. Winning streak example (58, 50, 52, 57, 55, 59, 53, 56). Percent of Jackpot winnings depends on the lowest bet amount and the distribution is represented below.',
        cn: '要赢得 Jackpot，您应在 Dice 游戏中押注。幸运组合必须以首位数匹配八次以 5x -> 5x -> 5x -> 5x -> 5x -> 5x -> 5x -> 5x（含），其中 x 是任意数字。连胜示例（58、50、52、57、55、59、53、56）。累积奖金的百分比取决于最低押注金额，分配如下所示。'
    },
    circleDescText1: {
        cn: '要赢得 Jackpot 您应该在 Circle 游戏中押注。有一个押注倒计时（每个累积奖金回合总共100,000个押注）。无论您输赢，您的押注都将计入 Jackpot 抽奖。一旦 100,000 个押注的倒计时重新开始，Jackpot 分配将开始。累积奖金的百分比取决于最低押注金额，分配如下所示。',
        en: 'To win Jackpot you should place bets in Circle game. There is a countdown of bets (total 100 000 bets for every Jackpot round). No matter you win or lose your bet will be counted in Jackpot draw. Jackpot distribution will start once countdown of 100 000 bets is restarted. Percent of Jackpot winnings depends on the lowest bet amount and the distribution is represented below.'
    },
    circleImgText: {
        cn: '剩余的Jackpot : ',
        en: 'Jackpot Round bets left:'
    },
    spaceDiceDescText1: {
        cn: '幸运组合包括连续四次带有7的数字序列，无论押注结果如何。',
        en: 'The lucky combination includes the sequence of numbers with special digits four times in a row, whatever the outcome of the bet is.'
    },
    spaceDiceDescText2: {
        cn: '不过，这些数字的顺序并不重要。',
        en: 'However, the order of these numbers does not matter.'
    },
    spaceDiceDescText3: {
        cn: 'Jackpot 中奖的百分比取决于最低押注金额。',
        en: 'The percent of Jackpot winning depends on the lowest bet amount.'
    },
    spaceDiceDescInfo1: {
        cn: '1 次任何的 4 位数字以 7 开头- 7xxx',
        en: '1 time any 4-digit number starting with 7 - 7xxx'
    },
    spaceDiceDescInfo2: {
        cn: '（从 7000 到 7999）',
        en: '(from 7000 to 7999)'
    },
    spaceDiceDescInfo3: {
        cn: '3 次任何的 4 位数字以 77 开头 - 77xx、77xx、77xx',
        en: '3 times any 4-digit numbers starting with 77 - 77xx, 77xx, 77xx'
    },
    spaceDiceDescInfo4: {
        cn: '（从 7700 到 7799)',
        en: '(from 7700 to 7799)'
    },
    spaceDiceDescInfo5: {
        cn: '连胜示例：7456、7789、7723、7777。',
        en: 'Winning streak example: 7456, 7789, 7723, 7777.'
    },
    hiloDescText1: {
        en: 'To win Jackpot you should place bets in Hi-Lo game. The lucky combination is a sequence of cards with a nominal of 7 any suit in one gaming round (the initial card is not counted), skipping the card will discard the previous progress. Percent of Jackpot winnings depends on the bet amount and the distribution is represented below.',
        cn: '要赢得 Jackpot ，您应在 Hi-Lo 游戏中押注并集齐 4 种花色＂7＂的牌（初始牌不计算在内），跳过牌将丢失进度。 Jackpot 奖金百分比取决于押注金额，分配如下所示。'
    },
    crashDescText1: {
        en: 'To win Jackpot you should place bets in Crash game. Players will start a race for collecting x80 000 sums of winning coefficients and the first who will reach those amount will get Jackpot. Example you win with 1.85 (you will get +0.85 to your total amount in Jackpot race).',
        cn: '要赢得Jackpot需在 Crash 游戏中押注以集得合計共 x80000 的获胜總倍率，並由第一个达到的玩家赢得Jackpot。若您以 1.85 倍获胜，将获得 Jackpot 总金额的 1.85倍。'
    },
    crashDescText4: {
        cn: '可贏得的Jackpot百分比取决于最小押注，其分配如下：',
        en: 'Percent of Jackpot winnings depends on the lowest bet amount and the distribution is represented below.'
    }
}


// ▼ 在游戏进行中离场时弹出的提示
export const oLeavingTips = {
    title: {
        en: 'Please confirm',
        cn: '请确认',
    },
    gameRunning: {
        en: 'The game is about to begin. Do you want to leave? You can return to continue the game.',
        cn: '本局游戏仍在进行中，是否确认离开？返回后可继续本局游戏。',
    },
    gameRunningZhajinhua: {
        en: "You have an unfinished Texas Hold'em game. Please confirm to continue.",
        cn: '您有炸金花游戏尚未结束，确认后继续',
    },
    inTableZhajinhua: {
        en: "ou are already at the Texas Hold'em table. Please confirm and continue.",
        cn: '您已在炸金花牌桌，确认后继续',
    },
    willSave: {
        en: 'When returning to the game again, the current game will be loaded',
        cn: '再次回到游戏时将加载本局游戏',
    },
    confirm: {
        en: 'Confirm',
        cn: '确认离开',
    },
    cancel: {
        en: 'continue game',
        cn: '继续游戏',
    },
    forceCanCel: {
        en: 'Force quit',
        cn: '强制退出',
    },
    tips: {
        en: 'Kind tips',
        cn: '温馨提示',
    },
};


// ▼ 导航左上角菜单内容
export const oHeaderMenu = {
    HomePage: {
        en: 'Home page',
        cn: '返回大厅',
    },
    GameHistory: {
        en: 'Game history',
        cn: '游戏记录',
    },
    AccountStatement: {
        en: 'Account statement',
        cn: '资金变动',
    },
    notification: {
        en: 'Notification',
        cn: '通知',
    },
};



// ▼ 导航左上角菜单内容
export const oAvatarManagemtn = {
    ChangeTheAvatar: {
        en: 'Change the avatar',
        cn: '更换头像',
    },
    TakePictures: {
        en: 'Take pictures',
        cn: '拍照上传',
    },
    Upload: {
        en: 'Upload',
        cn: '本地上传',
    },
    reset: {
        en: 'Reset',
        cn: '复位',
    },
    rotate: {
        en: 'Rotate',
        cn: '旋转',
    },
    uploading: {
        en: 'Uploading',
        cn: '正在上传',
    },
    uploaded: {
        en: 'uploaded',
        cn: '上传成功',
    },
    uploadFailed: {
        en: 'Upload failed',
        cn: '上传失败',
    },
    noCameraAuthorization: {
        en: 'Failed to obtain camera authorization',
        cn: '未能取得摄像头授权',
    },
};






